import { createSelector } from '@reduxjs/toolkit';

import { StateWithSpinnerMessages } from '../store/spinnerMessagesSlice';

export const areAnySpinnersActive = createSelector(
  (state: StateWithSpinnerMessages) => state.spinnerMessages,
  (spinnerMessages) => Object.keys(spinnerMessages).length > 0,
);

export const getSpinnersToDisplay = createSelector(
  (state: StateWithSpinnerMessages) => state.spinnerMessages,
  (spinnerMessages) => new Set(Object.values(spinnerMessages).map((spinner) => spinner.message)),
);
